import { IOption } from 'interfaces'
import { useEffect, useMemo } from 'react'
import useFetchApi, { isLoading } from 'hooks/useFetchApi/useFetchApi'
import uomService from 'Services/api/uom.service'

const useUOM = (showDescription: boolean = true) => {
    const [uoms = [], getAllUOMs, getUOMsStatus, , , setUOMs] = useFetchApi(
        uomService.getAllUOMs,
    )

    const uomOptions: IOption[] = useMemo(() => {
        return uoms.map((e) => ({
            label:
                `${e.symbol} ` +
                (showDescription ? `${e.name ? ` (${e.name})` : ''}` : ''),
            value: e.uomid!!,
        }))
    }, [uoms, showDescription])

    useEffect(() => {
        getAllUOMs()
    }, [getAllUOMs])

    return {
        uomOptions,
        uoms,
        loading: isLoading(getUOMsStatus),
        setUOMs,
    }
}

export default useUOM
